import React, { memo } from 'react';

const CloseIcon = () => {
	return (
		<svg
			width="19"
			height="19"
			viewBox="0 0 19 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M16.3903 17.9522C16.9182 18.4802 17.7743 18.4802 18.3023 17.9522C18.8302 17.4242 18.8302 16.5682 18.3023 16.0402L11.6103 9.34826L18.3022 2.65633C18.8302 2.12834 18.8302 1.27232 18.3022 0.744333C17.7743 0.21635 16.9182 0.21635 16.3902 0.744333L9.69828 7.43627L3.00625 0.744254C2.47826 0.21627 1.62223 0.216271 1.09425 0.744254C0.566262 1.27224 0.566261 2.12826 1.09425 2.65625L7.78628 9.34826L1.09423 16.0403C0.566246 16.5683 0.566246 17.4243 1.09423 17.9523C1.62222 18.4803 2.47825 18.4803 3.00623 17.9523L9.69828 11.2603L16.3903 17.9522Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default memo(CloseIcon);
